module.exports = __webpack_public_path__ + "static/media/6.question.925a3380.mp4";